module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prest-modulo-container",
    attrs: {
      "id": "cronogramaPagamento"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "solicitacao"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', {
    staticClass: "cabecalho"
  }, [_c('th', [_vm._v(" ")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado",
    attrs: {
      "colspan": "1",
      "title": '<h5>Valor total contratado no projeto por Atividade e Item</h5>'
    }
  }, [_vm._v("Orçado")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado",
    attrs: {
      "colspan": "1",
      "title": '<h5>Informe o que consta no documento (quantidade e valor)</h5>'
    }
  }, [_vm._v("Valor Documentos")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado",
    attrs: {
      "colspan": "1",
      "title": '<h5>Saldo restante de cada Atividade e Item</h5>'
    }
  }, [_vm._v("Saldo")])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('tbody', [_vm._l(((_vm.layoutExtrato === 'classico' ? [
    ['1', '5', '2']
  ] : (_vm.layoutExtrato === 'porOrigem') ? [
    ['1', '5']
  ] : [
    ['2']
  ])), function(origem) {
    return [(_vm.layoutExtrato === 'porOrigem') ? _c('tr', [_c('td', {
      staticClass: "atividade",
      attrs: {
        "colspan": "8"
      }
    }, [_vm._v(_vm._s((_vm._.includes(origem, '2')) ? 'Recursos de Contrapartida' : 'Recursos da Fundação BB'))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.cronograma.atividades), function(atividade) {
      return ((_vm._.filter(_vm.cronograma.itens, function(i) {
        return i.Atividade_nome === atividade.Nome && _vm._.includes((_vm.processo === 'CONTRAPARTIDA' ? ['2'] : ['1', '5']), ('' + i.Item_Origem).substring(0, 1)) && (!_vm._.has(i, 'mostrar') || i.mostrar)
      })).length > 0) ? [(_vm.layoutExtrato === 'classico') ? _c('tr', {
        staticClass: "atividade"
      }, [_c('td', {
        staticClass: "esquerda celula b1 b3 b4 nome_atividade"
      }, [_vm._v(_vm._s(atividade.Nome))]), _vm._v(" "), _c('td', {
        staticClass: "centralizado celula b1 b3 b4"
      }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
        staticClass: "centralizado celula b1 b3"
      }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
        staticClass: "centralizado celula b1 b3 b4"
      }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
        staticClass: "centralizado celula b1 b3"
      }, [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm._.filter(_vm.cronograma.itens, {
        'Atividade_nome': atividade.Nome
      })), function(item) {
        return (_vm._.includes((_vm.processo === 'CONTRAPARTIDA' ? ['2'] : ['1', '5']), ('' + item.Item_Origem).substring(0, 1)) && _vm.contasFinanceiras.includes(item.Item)) ? [(!_vm._.has(item, 'mostrar') || item.mostrar) ? [_c('tr', [_c('td', {
          staticClass: "celula b3 b4"
        }, [_c('div', {
          staticClass: "item",
          style: (_vm.usuarioLogado.userType === 'FUNDACAO' ? 'width: 80%; float: left;' : '')
        }, [_c('div', {
          staticClass: "item_despesa esquerda"
        }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.Item_Tipo))) + ")  " + _vm._s(item.Item + ' / ' + item.Item_Descricao))]), _vm._v(" "), _c('div', {
          staticClass: "observacao esquerda",
          domProps: {
            "innerHTML": _vm._s('<span class=id_item>#' + item.Id_item + '</span>  ' + item.Item_Observacao + '</span>')
          }
        })]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
          staticStyle: {
            "width": "20%",
            "text-align": "right",
            "float": "right",
            "color": "var(--cor-fraca)"
          }
        }, [_vm._v(_vm._s(item.Item_Conta))]) : _vm._e()]), _vm._v(" "), _c('td', {
          staticClass: "centralizado celula b3 b4"
        }, [_vm._v("\n                          " + _vm._s(_vm._f("decimal2")(item.Valor_orcado)) + "\n                        ")]), _vm._v(" "), _c('td', {
          staticClass: "centralizado celula b3 b4 valorSolicitacao"
        }, [_c('money', {
          staticClass: "form-control text-right valorSolicitacao",
          attrs: {
            "name": "valor a solicitar",
            "type": "text",
            "disabled": true
          },
          nativeOn: {
            "keyup": function($event) {
              item.Valor_solicitado = _vm.limitaFaixaEntrada('decimal', item.Valor_solicitado, 0, item.Valor_saldo)
            }
          },
          model: {
            value: (item.Valor_solicitado),
            callback: function($$v) {
              _vm.$set(item, "Valor_solicitado", $$v)
            },
            expression: "item.Valor_solicitado"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "centralizado celula b2 b3 b4"
        }, [_vm._v("\n                          " + _vm._s(_vm._f("decimal2")(item.Valor_saldo - parseFloat(item.Valor_solicitado))) + "\n                        ")]), _vm._v(" "), (_vm.usuarioLogado.userType == 'ENTIDADE') ? _c('td', {
          staticClass: "centralizado celula b2 b3 b4"
        }, [(parseFloat(item.Valor_saldo - item.Valor_solicitado) > 0) ? _c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true,
              placement: 'bottom'
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
          }],
          attrs: {
            "color": "primary",
            "size": "button--size-ss",
            "title": '<h5>Clique para Inserir um Novo Documento Fiscal</h5>'
          },
          nativeOn: {
            "click": function($event) {
              return _vm.toggleEdicao(true, item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus-circle",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Inserir\n                          ")]) : _c('div', {
          staticClass: "prest-max-solicitado"
        }, [_c('i', [_vm._v("Valores totais já informados.")])])], 1) : _vm._e()])] : _vm._e()] : _vm._e()
      })] : _vm._e()
    })]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-end prest-valor-total"
  }, [_c('div', {
    staticClass: "row-flex all-end"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "prest-valor-total"
  }, [_vm._v("Valor total do cronograma: "), _c('b', [_vm._v(_vm._s(_vm._f("real")(_vm.cronograma.totais.valor_total_contratado)))])])])])])])])]), _vm._v(" "), (_vm.editando) ? _c('div', {
    staticClass: "column all-start prest-fade",
    class: _vm.editandoNotaCadastrada ? 'prest-edicao-nota-container' : 'prest-cadastro-nota-container',
    attrs: {
      "id": "solicitacao"
    }
  }, [(_vm.loading.documentos) ? _c('div', {
    staticClass: "overlay-loading"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "prest-title",
    attrs: {
      "id": "cadastroDocumento"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.editandoNotaCadastrada ? 'Edição de Nota' : 'Cadastro de Nota') + " "), _c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.nota.fornecedor_tipo) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "column centered-start prest-nota-atividade-container"
  }, [_c('div', {
    staticClass: "prest-atividade-row"
  }, [_c('i', {
    staticClass: "fa fa-bookmark"
  }), _vm._v(" " + _vm._s(this.nota.itemOrcamento.Atividade_nome) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start prest-atividade-row"
  }, [_c('span', {
    staticClass: "prest-id-item"
  }, [_vm._v("#" + _vm._s(this.nota.itemOrcamento.Id_item))]), _vm._v("\n            [" + _vm._s(this.nota.itemOrcamento.Item) + "] " + _vm._s(this.nota.itemOrcamento.Item_Descricao) + " - " + _vm._s(this.nota.itemOrcamento.Item_Observacao) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start prest-atividade-row"
  }, [_c('b', [_vm._v("Valor Orçado:")]), _vm._v(" " + _vm._s(_vm._f("real")(this.nota.itemOrcamento.Valor_orcado)) + "\n            "), _c('u', [_c('b', [_vm._v("Saldo Restante:")]), _vm._v(" " + _vm._s(_vm._f("real")((this.nota.itemOrcamento.Valor_saldo - this.nota.itemOrcamento.Valor_solicitado) - this.nota.valor_documento)))])]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start prest-atividade-row"
  }, [_vm._v("\n            Período Execução do Projeto: \n            "), _c('b', [_vm._v("Inicio:")]), _vm._v(" " + _vm._s(_vm.dataInicial) + " \n            e\n            "), _c('b', [_vm._v("Fim:")]), _vm._v(" " + _vm._s(_vm.dataFinal) + "\n          ")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row-flex w-100"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: (_vm.errors.first('número da nota') ? ' has-error' : '')
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Descreva o Item do Documento:\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.item),
      expression: "nota.item"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "70"
    },
    domProps: {
      "value": (_vm.nota.item)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nota, "item", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("\n                    " + _vm._s(_vm.nota.item ? _vm.nota.item.length : 0) + "/70 caracteres\n                ")]), _vm._v(" "), (_vm.nota.item && _vm.nota.item.length === 70) ? _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("\n    Limite máximo de 70 caracteres atingido.\n")]) : _vm._e(), _vm._v(" "), (_vm.errors.first('número da nota')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('número da nota')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: (_vm.errors.first('número da nota') ? ' has-error' : '')
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Valor:\n                ")]), _vm._v(" "), _c('money', {
    staticClass: "form-control text-right",
    attrs: {
      "name": "valorNota",
      "type": "text"
    },
    nativeOn: {
      "keyup": function($event) {
        _vm.nota.valor_documento = _vm.limitaFaixaEntradaInput('decimal', _vm.nota.valor_documento, 0, (_vm.nota.itemOrcamento.Valor_saldo - _vm.nota.itemOrcamento.Valor_solicitado))
      }
    },
    model: {
      value: (_vm.nota.valor_documento),
      callback: function($$v) {
        _vm.$set(_vm.nota, "valor_documento", $$v)
      },
      expression: "nota.valor_documento"
    }
  }), _vm._v(" "), (_vm.errors.first('número da nota')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('número da nota')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row-flex w-100"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: (_vm.errors.first('número da nota') ? ' has-error' : '')
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Número do Documento (apenas números):\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.numero_documento),
      expression: "nota.numero_documento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "número da nota",
      "type": "text"
    },
    domProps: {
      "value": (_vm.nota.numero_documento)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nota, "numero_documento", $event.target.value)
      }, _vm.formatarNumeroDocumento]
    }
  }), _vm._v(" "), (_vm.errors.first('número da nota')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('número da nota')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('série')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Série:")]), _vm._v(" "), _c('div', [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.serie_documento),
      expression: "nota.serie_documento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "série"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.nota, "serie_documento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "NOTA_FISCAL"
    }
  }, [_vm._v("1 - Nota fiscal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RECIBO_PAGAMENTO_AUTONOMO"
    }
  }, [_vm._v("10 - Recibo de pagamento a autônomo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DOCUMENTO_NAO_FISCAL"
    }
  }, [_vm._v("DNF - Documento não fiscal")])])]), _vm._v(" "), (_vm.errors.first('série')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('série')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row-flex w-100"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('data de emissão')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de emissão do documento:")]), _vm._v(" "), _c('div', [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "data de emissão",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "disabled-dates": {
        to: new Date(_vm.dataInicioSapiens),
        from: new Date()
      },
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.nota.data_emissao_documento),
      callback: function($$v) {
        _vm.$set(_vm.nota, "data_emissao_documento", $$v)
      },
      expression: "nota.data_emissao_documento"
    }
  })], 1)]), _vm._v(" "), (_vm.errors.first('data de emissão')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data de emissão')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de validade do documento: (Somente informe se possuir a data)")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    attrs: {
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.nota.data_validade_documento),
      callback: function($$v) {
        _vm.$set(_vm.nota, "data_validade_documento", $$v)
      },
      expression: "nota.data_validade_documento"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column all-start prest-cadastro-nota-container",
    attrs: {
      "id": "solicitacao"
    }
  }, [_vm._m(4), _vm._v(" "), (_vm.loading.tela) ? _c('div', {
    staticClass: "overlay-loading"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row-flex w-100"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('tipo de pessoa')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Tipo de pessoa:")]), _vm._v(" "), _c('div', [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.fornecedor_tipo),
      expression: "nota.fornecedor_tipo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tipo de pessoa",
      "disabled": _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.nota, "fornecedor_tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.bloqueiaCamposFornecedorExistente = false, _vm.nota.fornecedor_nome = '', _vm.nota.fornecedor_cep = '', _vm.nota.fornecedor_endereco = '', _vm.nota.fornecedor_cpf_cnpj = '', _vm.nota.fornecedor_codigo = ''
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "Pessoa Física"
    }
  }, [_vm._v("Pessoa Física")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pessoa Jurídica"
    }
  }, [_vm._v("Pessoa Jurídica")])])]), _vm._v(" "), (_vm.errors.first('tipo de pessoa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de pessoa')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row-flex w-100"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.nota.fornecedor_tipo === 'Pessoa Jurídica') ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cnpj')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row-flex"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-control",
    style: (_vm.usuarioLogado.userType === 'FUNDACAO' ? 'width: 65%; float: left' : ''),
    attrs: {
      "name": "cnpj",
      "mask": ['NN.NNN.NNN/NNNN-##'],
      "tokens": _vm.$cnpjTokens,
      "disabled": _vm.bloqueiaCamposFornecedorExistente,
      "type": "text"
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.verificaCpfCnpjSapiens(_vm.nota.fornecedor_cpf_cnpj)
      }
    },
    model: {
      value: (_vm.nota.fornecedor_cpf_cnpj),
      callback: function($$v) {
        _vm.$set(_vm.nota, "fornecedor_cpf_cnpj", $$v)
      },
      expression: "nota.fornecedor_cpf_cnpj"
    }
  }), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "width": "35%",
      "float": "left",
      "margin-left": "1%"
    },
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.nota.fornecedor_codigo
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.errors.first('cnpj')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cnpj')))]) : _vm._e(), _vm._v(" "), (_vm.errors.first('cnpj vinculado a dirigente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cnpj vinculado a dirigente')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.nota.fornecedor_tipo === 'Pessoa Física') ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cpf')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-control",
    style: (_vm.usuarioLogado.userType === 'FUNDACAO' ? 'width: 65%; float: left' : ''),
    attrs: {
      "name": "cpf",
      "mask": ['###.###.###-##'],
      "disabled": _vm.bloqueiaCamposFornecedorExistente,
      "type": "text"
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.verificaCpfCnpjSapiens(_vm.nota.fornecedor_cpf_cnpj)
      }
    },
    model: {
      value: (_vm.nota.fornecedor_cpf_cnpj),
      callback: function($$v) {
        _vm.$set(_vm.nota, "fornecedor_cpf_cnpj", $$v)
      },
      expression: "nota.fornecedor_cpf_cnpj"
    }
  }), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "width": "30%",
      "float": "left",
      "margin-left": "5%"
    },
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.nota.codigoFornecedor
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.errors.first('cpf')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf')))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm._.has(_vm.nota, 'fornecedor_tipo') && !_vm._.isNull(_vm.nota.fornecedor_tipo)) ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('nome')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.fornecedor_nome),
      expression: "nota.fornecedor_nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^[A-Za-zÀ-ÿ0-9\s.\-\/()&$*'\x22]+$/
      }),
      expression: "{ required: true, regex: /^[A-Za-zÀ-ÿ0-9\\s.\\-\\/()&$*'\\x22]+$/ }"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text",
      "disabled": _vm.bloqueiaCamposFornecedorExistente,
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.nota.fornecedor_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nota, "fornecedor_nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row-flex w-100"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm._.has(_vm.nota, 'fornecedor_tipo') && !_vm._.isNull(_vm.nota.fornecedor_tipo)) ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('endereço')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Endereço:")]), _vm._v(" "), _c('div', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.fornecedor_endereco),
      expression: "nota.fornecedor_endereco"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "endereço",
      "type": "text",
      "disabled": _vm.bloqueiaCamposFornecedorExistente
    },
    domProps: {
      "value": (_vm.nota.fornecedor_endereco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nota, "fornecedor_endereco", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('endereço ')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('endereço')))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm._.has(_vm.nota, 'fornecedor_tipo') && !_vm._.isNull(_vm.nota.fornecedor_tipo)) ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cep')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CEP:")]), _vm._v(" "), _c('div', [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cep",
      "mask": ['#####-###'],
      "disabled": _vm.bloqueiaCamposFornecedorExistente
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.procurandoCidadeUF($event)
      }
    },
    model: {
      value: (_vm.nota.fornecedor_cep),
      callback: function($$v) {
        _vm.$set(_vm.nota, "fornecedor_cep", $$v)
      },
      expression: "nota.fornecedor_cep"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('cep')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cep')))]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.nota.cidadeFornecedor) ? _c('div', {
    staticClass: "prest-municipio"
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" \n              " + _vm._s(_vm.nota.cidadeFornecedor) + " " + _vm._s((_vm.nota.estadoFornecedor) ? ' / ' + _vm.nota.estadoFornecedor : '') + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body prest-upload-container"
  }, [_vm._m(5), _vm._v(" "), _c('uploadDocumentosPhpPrestacao', {
    attrs: {
      "propDocumentos": _vm.nota.anexos,
      "documentTypes": '',
      "local-uso": 'SOLICITACAO_PAGAMENTO',
      "desvinculaAnexo": _vm.desvinculaAnexo,
      "restricaoArquivo": true
    }
  })], 1)]), _vm._v(" "), (_vm.notaJaCadastradaNestaPrestacao) ? _c('div', {
    staticClass: "column start-centered prest-aviso-repetido-container"
  }, [_c('div', {
    staticClass: "row-flex start-between prest-aviso-close"
  }, [_vm._m(6), _vm._v(" "), _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.notaJaCadastrada = false
      }
    }
  })]), _vm._v(" "), _c('div', [_vm._v("\n              Atenção! Este documento já foi lançado anteriormente:\n              "), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start prest-checkbox-container"
  }, [_c('div', {
    staticClass: "f-required"
  }, [_vm._v("\n                   Há necessidade de lançar novamente:\n                  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notaRepetida.necessidade),
      expression: "notaRepetida.necessidade"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "notaJaCadastrada",
      "name": "notaJaCadastrada"
    },
    domProps: {
      "checked": Array.isArray(_vm.notaRepetida.necessidade) ? _vm._i(_vm.notaRepetida.necessidade, null) > -1 : (_vm.notaRepetida.necessidade)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.notaRepetida.necessidade,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.notaRepetida, "necessidade", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.notaRepetida, "necessidade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.notaRepetida, "necessidade", $$c)
        }
      }, function($event) {
        return _vm.verificaValidacao()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start prest-checkbox-container"
  }, [_c('div', {
    staticClass: "f-required"
  }, [_vm._v("\n                   Está ciente da responsabilidade pelas informações prestadas:\n                  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notaRepetida.responsabilidade),
      expression: "notaRepetida.responsabilidade"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "notaJaCadastrada",
      "name": "notaJaCadastrada"
    },
    domProps: {
      "checked": Array.isArray(_vm.notaRepetida.responsabilidade) ? _vm._i(_vm.notaRepetida.responsabilidade, null) > -1 : (_vm.notaRepetida.responsabilidade)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.notaRepetida.responsabilidade,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.notaRepetida, "responsabilidade", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.notaRepetida, "responsabilidade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.notaRepetida, "responsabilidade", $$c)
        }
      }, function($event) {
        return _vm.verificaValidacao()
      }]
    }
  })]), _vm._v(" "), _c('div', [_vm._v("\n                *Informe apenas o valor do ITEM da nota fiscal.\n               ")]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start prest-button-container"
  }, [_c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": _vm.editandoNotaCadastrada ? 'primary' : 'success',
      "size": "button--size-ss",
      "title": _vm.editandoNotaCadastrada ? '<h5>Clique para Salvar Edição</h5>' : '<h5>Clique para Adicionar a Nota</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvarNota()
      }
    }
  }, [_c('i', {
    class: _vm.editandoNotaCadastrada ? 'fa fa-save' : 'fa fa-plus-circle',
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.editandoNotaCadastrada ? 'Salvar Edição' : 'Adicionar') + "\n          ")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "warning",
      "size": "button--size-ss",
      "title": '<h5>Clique para Cancelar</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEdicao(false, null, true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar\n          ")])], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "prest-box-title row-flex centered-start"
  }, [_vm._v("Cronograma "), _c('i', {
    staticClass: "fa fa-calendar-check-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n        Encontre o item do cronograma que deseja vincular o documento fiscal e clique em "), _c('b', [_vm._v("Inserir")]), _vm._v(".\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "cabecalho"
  }, [_c('th', [_vm._v("Atividade / Recursos (itens do cronograma)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Dados do Documento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Fornecedor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "prest-box-title row-flex centered-start"
  }, [_vm._v("Documento Fiscal "), _c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('strong', [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Atenção")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63f61c16!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/prestacaoContasSimplificado/cronogramaGED.vue
// module id = 1985
// module chunks = 1